import { FileXlsIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Excel = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <FileXlsIcon size={Sizes[size]} {...rest} color={fill} />;
};

Excel.displayName = 'Excel';
